"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECTION_TITLE = exports.MOBILE_VIEW_LAYOUTS_SNAKE_CASE = exports.DisplayViewOptions = void 0;
var MOBILE_VIEW_LAYOUTS_SNAKE_CASE = {
  verticallyStacked: 'vertically-stacked',
  horizontallyScrollable: 'horizontally-scrollable'
};
exports.MOBILE_VIEW_LAYOUTS_SNAKE_CASE = MOBILE_VIEW_LAYOUTS_SNAKE_CASE;
var DisplayViewOptions = {
  List: 'list',
  Card: 'card'
};
exports.DisplayViewOptions = DisplayViewOptions;
var SECTION_TITLE = {
  Content: 'Content',
  Template: 'Layout',
  WidgetStyle: 'Style',
  Buttons: 'Buttons',
  Image: 'Image',
  ProductSharedVisibility: 'PRODUCT SHARED VISIBILITY'
};
exports.SECTION_TITLE = SECTION_TITLE;